//----------------------------Add multiple products-------------------------------------//



$(function(){
      $('.custom-add-to-cart-t').click(function(event){
        
         $(this).addClass('btn--loading');  

        event.preventDefault()
        
        if ($('input.add_checkbox').is(':checked')) {
        var val = [];
        $('.add_checkbox:checked').each(function(i){
          val[i] = $(this).val();
          
          console.log($(this).val());
          
          
          
          addAllItems(val);
          
           
          
        });
          
        }
        else
        {
         var product_id = $(this).closest('form').find('input[name="id"]').val();
          
          addItemToCart(product_id, 1)

          function addItemToCart(variant_id, qty) {


           var data = {
              "id": variant_id,
              "quantity": qty
            }
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function() { 

                $(".custom-add-to-cart").removeClass('btn--loading');  

                document.dispatchEvent(new CustomEvent('cart:build'));

               // $("#cart_call")[0].click();

                 document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));
                
                // Start countdown timer
                document.dispatchEvent(new CustomEvent('cart:change', {
                    bubbles: true
                }));

              }
            });

          }
     
        }  
        
        
        
      });
  
     
  
    });



      function addAllItems(array){
        Shopify.queue = [];
 
      //  var quantity = {{ cart.item_count }} ;
      
    //  var newArray = array.split(',');
        
        var newArray = array;

      for (var i = 0; i < newArray.length; i++) {
       var product = newArray[i]
        Shopify.queue.push({
          variantId: product,
        });
      }
      Shopify.moveAlong = function() {
        // If we still have requests in the queue, let's process the next one.
        if (Shopify.queue.length) {
          var request = Shopify.queue.shift();
          var data = 'id='+ request.variantId + '&quantity=1'
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: data,
            success: function(res){
              Shopify.moveAlong();
            //  quantity += 1;
            },
            error: function(){
              // if it's not last one Move Along else update the cart number with the current quantity
              if (Shopify.queue.length){
                Shopify.moveAlong()
              } else {
               // $('#cart-number').replaceWith("<a href="/cart" id="cart-number">View cart (" + quantity + ")</a>");
                
                console.log('Error in Prodcut adding');
              }
            }
          });
        }
        // If the queue is empty, we add 1 to cart
        else {
          console.log(' 1 product adding');
          
         addCurrenctProduct();
          
          $('.custom-add-to-cart').removeClass('btn--loading'); 
          
          
          document.dispatchEvent(new CustomEvent('cart:build'));

         // $("#cart_call")[0].click();

           document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));
                
          // Start countdown timer
          document.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true
          }));
             
        }
      };
      Shopify.moveAlong();
       
        
    };



function addCurrenctProduct(){

  var product_id = $(this).closest('form').find('input[name="id"]').val();
          
          
        

          console.log("current product:"+ product_id);
          
         var  arr = {
              "id": product_id,
              "quantity": 1
            }
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: arr,
              dataType: 'json',
              success: function() { 

               document.dispatchEvent(new CustomEvent('cart:build'));

              }
            });

          
}
